import DataSource from '../../assets/SraRunTable-ONT'


const createHomeStore = (set) => {

  // 日期格式化
  const getFormatDate = (value) => {
    if (value !== '') {
      const date = new Date(value)
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      const formatDate = `${year}/${month}/${day}`
      return formatDate
    } else {
      return ''
    }
  }

  const dateColumns = ['create_date', 'ReleaseDate', 'Collection_Date']

  const updatedData = DataSource.map(e => {
    let newObj = { ...e } // 创建新对象以防止更改原数据
    dateColumns.forEach(columnName => {
      newObj[columnName] = getFormatDate(newObj[columnName])
    })

    return newObj // 返回更新后的对象
  })

  return {
    homeData: updatedData,
    queryData: updatedData,
    loadingData: false,
    setQueryData: (value) => {
      set(state => ({ queryData: value }))
    },
    setLoadingData: (bool) => set({ loadingData: bool })
  }
}

export { createHomeStore }